import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TBootsColor } from "../../../Interfaces/Utils/Style/StyleInterfaces";

interface ITimelineItemProps {
    icon: IconProp;
    iconColor: TBootsColor;
    iconTooltipText?: string;
    className?: string;
    subHeader?: React.ReactNode;
    title?: string;
    date: Date;
    children: React.ReactNode;
    footer?: React.ReactNode;
}

export default function TimelineItem(props: ITimelineItemProps) {
    return (
        <div className="timeline-item">
            <OverlayTrigger
                overlay={
                    <Tooltip id="tooltip-timeline">
                        {props.iconTooltipText}
                    </Tooltip>
                }
                show={props.iconTooltipText ? undefined : false}
            >
                <div className={`timeline-media text-${props.iconColor}`}>
                    <FontAwesomeIcon icon={props.icon} size="2x" />
                </div>
            </OverlayTrigger>

            <div className={`timeline-content ${props.className}`}>
                <div className="d-flex align-items-center flex-wrap-reverse justify-content-between mb-3">
                    <div className="mr-2 d-flex flex-wrap flex-column">
                        <span className="text-dark-75 font-weight-bold mr-2">
                            {props.title}
                        </span>
                        <span className="text-muted">
                            {moment(props.date).format("lll")}
                        </span>
                    </div>
                    <span className="d-flex flex-grow-1">
                        {props.subHeader}
                    </span>
                </div>

                <div className="w-100">{props.children}</div>

                <div className="w-100">{props.footer}</div>
            </div>
        </div>
    );
}
